import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import './GlobalEduCare.css';
import boss2 from './edu-care.jpg';
import { Link } from 'react-router-dom';



const GlobalEduCare = () => {
    return (
        <div>

            <div className='eduCareContainer container'>

                <Grid container spacing={2} className='row align-items-center container forBG'>
                    <section item className='col-md-5'>
                        <div className='text-center'>
                            <img className='responsive my-5' src={boss2} alt="" />
                        </div>
                    </section>
                    <section item className='col-md-7'>
                        <div >

                            <div>
                                <div class="center-wrap ceo-title">
                                    <div class="title-container">
                                        <div class="title"><a href="http://antgec.com/">Web Developer at Education Care</a></div>
                                    </div>
                                </div>
                                <Box>
                                    <p><strong> 25 March 2024 - 30 April 2025 </strong></p>
                                    <p className='forText'>At Global Education Care, I developed and maintained dynamic websites using the MERN stack (MongoDB, Express.js, React, Node.js). My work involved building and deploying scalable web applications that enhanced user engagement and experience, contributing to a significant increase in site traffic. By engineering responsive and interactive websites, I ensured seamless functionality across various devices and platforms. Collaborating with cross-functional teams, I designed and developed robust web solutions that streamlined educational resource management and improved operational efficiency. My contributions to creating custom web applications supported Global Education Care’s growing user base and strengthened their online presence.
                                    </p>
                                </Box>
                                <Box>
                                    Visit Us : <Link to="https://gecare.co.uk/" target="blank"> <span className='email'>https://gecare.co.uk</span> </Link>
                                    <Box className="edu-care-social-media">
                                        <strong>Follow Us On :</strong> <Link to="https://www.facebook.com/globaleducationcareltd" target='blank'> <i class="fab fa-facebook"></i> </Link>  <Link to="https://www.linkedin.com/company/education-care/" target='blank'> <i class="fab fa-linkedin"></i> </Link>
                                    </Box>
                                </Box>
                            </div>

                        </div>
                    </section>

                </Grid>

            </div>
            {/* <div>
                <MyCarousel />
            </div> */}
        </div>
    );
};

export default GlobalEduCare;